import { useContext } from 'react';

import { KorintConfigContext, type KorintConfigContextType } from '../KorintConfigProvider';

export const useKorintConfig = (): KorintConfigContextType => {
  return useContext(KorintConfigContext);
};
